import React from 'react';

import { i18n } from 'config/locales';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import { FINANCIAL, FINANCIAL_REPOSSESSION } from 'config/formSections/financial';

import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import { DateSummary, Summary } from 'components/Summary';
import RepossessionItem from './RepossessionItem';

const sectionConfig = {
  key: FINANCIAL_REPOSSESSION.key,
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_REPOSSESSION.name,
  storeKey: FINANCIAL_REPOSSESSION.storeKey,
};

export class Repossession extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
    this.summary = this.summary.bind(this);
  }

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const date = DateSummary(o.When);
    const propertyType = (o.PropertyType || {}).value || '';

    return Summary({
      type: i18n.t('financial.pvq.repossession.summary.type'),
      index,
      left: propertyType,
      right: date,
      placeholder: i18n.t('financial.pvq.repossession.summary.unknown'),
    });
  };

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      HasRepossession: this.props.HasRepossession,
      List: this.props.List,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateHasRepossession = (values) => {
    this.update({
      HasRepossession: values,
      List: values.value === 'Yes' ? this.props.List : { items: [], branch: {} },
    });
  };

  render() {
    const {
      errors,
      required,
      scrollIntoView,
      scrollToBottom,
      defaultState,
      dispatch
    } = this.props;

    const accordionErrors = errors && errors.filter((e) => e?.indexOf?.('List.accordion') === 0);

    return (
      <div
        className="section-content repossession"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_REPOSSESSION.key}
      >
        <h1 className="section-header">{i18n.t('financial.pvq.destination.repossession')}</h1>
        <Branch
          name="has_repossession"
          label={i18n.t('financial.pvq.repossession.branch.title')}
          labelSize="h4"
          className="repossession-branch"
          {...this.props.HasRepossession}
          warning
          onUpdate={this.updateHasRepossession}
          required={required}
          scrollIntoView={scrollIntoView}
          onError={this.handleError}
          attribute="HasRepossession"
        />
        <Show when={(this.props.HasRepossession || {}).value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={defaultState}
            scrollToBottom={scrollToBottom}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={required}
            errors={accordionErrors}
            summary={this.summary}
            scrollIntoView={scrollIntoView}
            appendTitle={i18n.t('financial.pvq.repossession.appendTitle')}
            attribute="List"
          >
            <RepossessionItem
              name="Item"
              dispatch={dispatch}
              required={required}
              scrollIntoView={scrollIntoView}
              bind
              attribute="List"
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

Repossession.defaultProps = {
  List: EmptyListInstance,
  HasRepossession: {},
  onUpdate: () => {},
  onError: (value, arr) => arr,
  dispatch: () => {},
  defaultState: true,
  scrollToBottom: '.bottom-btns',
  errors: [],
};

export default connectSubsection(Repossession, sectionConfig);
